import axios from 'axios';
import QS from 'qs';
import {Message} from 'element-ui';
import {get_session_cache, remove_session_cache} from "@/config/cache/cache.js"
import router from '@/router'

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = '/deviceapplet';
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = '/deviceapplet';
}
axios.defaults.timeout = 60*1000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
    config => {
        const token = get_session_cache("Access-Token");
        if((!!token) || router.currentRoute.name === 'Login'){
        }else{
            return Promise.reject('无token')
        }
        token && (config.headers['Access-Token'] = token)
        return config
    },
    error => {
        return Promise.error(error)
    }
)
let invalidFlag = true;
// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            // if(response.data.status === "ERROR"){
                // Message.error(response.data.message);
                // return Promise.reject(response);
            // }
            if(response.data.status === "INVALID"){
                if(invalidFlag){
                    invalidFlag = false;
                    Message.error(response.data.message)
                }
                if(router.currentRoute.name === 'preview'){
                    let query = router.currentRoute.query;
                    query.from = 'preview'
                    router.push({path:'/login',query})
                }else{
                    router.push('/login')
                }
                return Promise.reject(response);
            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (!!error.response && error.response.status) {
            switch (error.response.status) {
                // 401: 未登录       
                case 401:
                    window.location.href="/login";
                    break;
                // 403 token过期
                case 403:
                    // 清除token     
                    remove_session_cache("Access-Token");
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        window.location.href="/login";
                    }, 500);
                    break;
                // 404请求不存在
                case 404:
                    Message.error('请求不存在')
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    Message.error('系统错误')
            }
            return Promise.reject(error.response);
        }
        return Promise.reject(error)
    }
)

let exportTimeOut = 10*60*1000;

export let $http = async(type = 'POST', url = '', data = {}) => {
    let result
    type = type.toUpperCase()
    if (type === 'GET') {
        let params = {params: data};
        if(url.indexOf('export') !=-1){
            params.timeout = exportTimeOut;
        }
        await axios.get(url, params)
        .then(res => {
            result = res.data
        }).catch(err => {
            let errStr = err + '';
            if(errStr.indexOf('timeout of') != -1){
                result = {
                    status: "ERROR",
                    message: "访问超时。",
                    enMessage: "Access timeout."
                }
            }else{
                result = err;
                return Promise.reject(err);
            }
        })
    } else if (type === 'POST') {
        await axios.post(url, QS.stringify(data))
        .then(res => {
            result = res.data
        }).catch(err => {
            let errStr = err + '';
            if(errStr.indexOf('timeout of') != -1){
                result = {
                    status: "ERROR",
                    message: "访问超时。",
                    enMessage: "Access timeout."
                }
            }else{
                result = err;
                return Promise.reject(err);
            }
        })
    }
    return result
}

export let $httpForList = async (type='POST', url='', data={}, needP=true) => { // 提供文件上传类口封装
    let result;
    type = type.toUpperCase()
    if(type === 'POST'){
        let ops = data
        if(needP){
            ops = {params:data} 
        }
        await axios.post(url, ops, {
            headers: {
                'content-type': 'application/json;charset=UTF-8'
            },
            timeout: exportTimeOut
        })
            .then(res => {
                result = res.data
            }).catch(err => {
                result = err
                return Promise.reject(err)
        })
    }
    return result
}